import { render, staticRenderFns } from "./AssessmentGlobalSingleTaskModal.vue?vue&type=template&id=a13fbc26&scoped=true&"
import script from "./AssessmentGlobalSingleTaskModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentGlobalSingleTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentGlobalSingleTaskModal.vue?vue&type=style&index=0&id=a13fbc26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a13fbc26",
  null
  
)

export default component.exports